import TextComponent from "../../../components/textComponent/TextComponent";
import styles from "./AdminDashboard.module.css";
import { Button, List, Modal } from "antd";
import { Table } from "antd";
import HeadingComponent from "../../../components/HeadingComponent/HeadingComponent";
import { PiUsers } from "react-icons/pi";
import { LiaMoneyCheckAltSolid } from "react-icons/lia";
import { TbRosetteDiscountCheck } from "react-icons/tb";
import { GiMoneyStack } from "react-icons/gi";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "../../../Store/Actions/GeneralActions"
import { DashboardMiddleware } from "../../../Store/Middlewares/DashboardMiddleware";
import { useEffect, useState } from "react";
import moment from "moment/moment";
import Pagination from "../../../components/Pagination/Pagination";
import { AiOutlineCloseCircle } from "react-icons/ai";
import SubmitButton from "../../../components/submitButton/SubmitButton";
import { AuthMiddleware } from "../../../Store/Middlewares/AuthMiddleware";

const AdminDashboard = () => {


  const navigate = useNavigate();
  const dispatch = useDispatch();
  const FIGURES = useSelector(state => state.DashboardReducer?.dashboardData);
  const USERS = useSelector(state => state.DashboardReducer?.allUsers);
  const USERS_PAGINATION = useSelector(state => state.DashboardReducer?.allUsersPagination);

  const [currentPage, setCurrentPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(12);
  const [openDelModal, setopenDelModal] = useState(false)
  const [selectedUser, setSelectedUser] = useState(null)

  useEffect(() => {
    getData()
  }, []);

  const getData = (arg) => {
    const data = {
      limit: pageLimit,
      page: 1,
    };
    dispatch(DashboardMiddleware.onGetDashboardData(arg || data))
      .then((res) => { })
      .catch((err) => { console.log("Error fetching dashboard data:", err) });
  }


  const handleNavigate = (record) => {
    navigate('/UserDetails', { state: { userId: record?.id } });
  };

  const onPressDelUser = () => {
    dispatch(AuthMiddleware.onDelUser({ id: selectedUser?.id }))
      .then((res) => { })
      .catch((err) => {
        console.log("Error deleting user:", err);
      })
      .finally(() => {
        setopenDelModal(false)
        getData()
      });
  }



  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      key: "Id",
      render: (text, record, index) => {
        return (
          <TextComponent
            text={index + 1}
            style={{ color: "black" }}
          />
        );
      },
    },
    {
      title: "First Name",
      dataIndex: "firstName",
      key: "First Name",
      render: (text, record) => {
        return (
          <TextComponent
            text={text}
            style={{ color: "black" }}
          />
        );
      },
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      key: "Last Name",
      render: (text, record) => {
        return (
          <TextComponent
            text={text}
            style={{ color: "black" }}
          />
        );
      },
    },
    {
      title: "Date Created",
      key: "createdAt",
      dataIndex: "DateCreated",
      render: (text, record) => {
        return (
          <TextComponent
            text={moment(record?.createdAt).format("MMM, DD, YYYY")}
            style={{ color: "black" }}
          />
        );
      },
    },
    {
      title: "",
      key: "action",
      render: (_, record) => (
        <button className={styles.TableButton} onClick={() => handleNavigate(record)}>
          View
        </button>
      ),
    },
    {
      title: "",
      key: "action",
      render: (_, record) => (
        <button className={styles.TableButtonx} onClick={() => {
          setopenDelModal(true);
          setSelectedUser(record)
        }}>
          Delete
        </button>
      ),
    },
  ];

  const OverviewData = [
    {
      id: 1,
      logo: <PiUsers color={'var(--white-color)'} size={25} />,
      name: "Users count",
      price: FIGURES?.totalUser || 0,
    },
    {
      id: 2,
      logo: <GiMoneyStack color={'var(--white-color)'} size={25} />,
      name: "Revenue by ads",
      price: FIGURES?.revenueByAds || 0,
    },
    {
      id: 3,
      logo: <LiaMoneyCheckAltSolid color={'var(--white-color)'} size={25} />,
      name: "Revenue by yardsales",
      price: FIGURES?.revenueByYardSales || 0,
    },
    {
      id: 1,
      logo: <TbRosetteDiscountCheck color={'var(--white-color)'} size={25} />,
      name: "Total Yardsales",
      price: FIGURES?.totalYardSales || 0,
    },
  ];

  const renderOverview = (item, index) => {
    return (
      <div className={styles.rj_listItem}>
        <div className={styles.logoDiv}>{item?.logo}</div>
        <TextComponent text={item?.name} className={styles.overviewSpan} />
        <TextComponent text={item?.price} className={styles.overviewText} />
      </div>
    );
  };


  return (
    <div className={styles.mainCon}>
      <div className={styles.HeaderDiv}>
        <HeadingComponent padding={"0px"} text={"Welcome "} />
        <HeadingComponent
          text="Admin!"
          padding={"0px"}
          color={"var(--primary-color)"}
        />
      </div>

      <div className={styles.secondDiv}>
        <div className={styles.OverviewDiv}>
          <div className={styles.OverviewHeadingDiv}>
            <HeadingComponent
              text={"Statistics Overview"}
              fontSize="var(--heading2-font-size)"
              padding={"0px"}
            />
          </div>
          <div>
            <List
              dataSource={OverviewData}
              renderItem={renderOverview}
              style={{ marginTop: 20 }}
              grid={{
                gutter: 18,
                xs: 1,
                sm: 2,
                md: 2,
                lg: 4,
                xl: 4,
                xxl: 3,
              }}
            />
          </div>
        </div>
      </div>


      <div className={styles.TableHeadingRow}>
        <HeadingComponent
          text={"Users"}
          fontSize="var(--heading2-font-size)"
          padding={"0px"}
        />


        {/* <Button className={styles.AddUserButton} onClick={() => navigate("/CreateNewUser")}>Create User</Button> */}

      </div>
      <div className={styles.TableDiv}>

        <Table
          scroll={{ x: true }}
          columns={columns}
          dataSource={USERS}
          pagination={false}
          style={{
            boxShadow: 'rgba(0, 0, 0, 0.15) 0px 5px 15px 0px',
          }}


        />

        {

          (USERS_PAGINATION?.totalPages > 1) &&
          <Pagination
            currentPage={currentPage}
            totalPages={USERS_PAGINATION?.totalPages}
            nextButton={(e) => {
              getData({
                limit: pageLimit,
                page: currentPage + 1,
              });
              setCurrentPage(currentPage + 1);
            }}
            previousButton={(e) => {
              getData({
                limit: pageLimit,
                page: currentPage - 1,
              });
              setCurrentPage(currentPage - 1);
            }}
          />
        }

      </div>

      <Modal
        footer={false}
        closeIcon={<AiOutlineCloseCircle color="black" size={20} />}
        open={openDelModal}
        onCancel={() => {
          setopenDelModal(false)
        }}
      >
        <div className={styles.modal}>
          <TextComponent text={"Delete User"} className={'modalheading'} />
          <TextComponent text={`Are you sure you want to delete ${selectedUser?.firstName} ${selectedUser?.lastName}`} className={'modalText'} />


          <div className={'modalFooter'}>

            <SubmitButton
              title={"No"}
              btnClass={'modalBtn'}
              primary
              onClick={() => setopenDelModal(false)}
            />


            <SubmitButton
              title={"Yes"}
              btnClass={'modalBtn'}
              secondaryBtn
              onClick={onPressDelUser}
            />
          </div>

        </div>
      </Modal>

    </div>
  );
};

export default AdminDashboard;
